import AxiosInstance from 'utils/AxiosInstance'
import * as types from './types'

export const setLatestToolbox = (toolbox) => ({
  type: types.SET_LATEST_TOOLBOX,
  payload: toolbox,
})

export const setAdminToolbox = (toolbox) => ({
  type: types.SET_ADMIN_TOOLBOX,
  payload: toolbox,
})

export const setManagerToolbox = (toolbox) => ({
  type: types.SET_MANAGER_TOOLBOX,
  payload: toolbox,
})

export const setEmployeeToolbox = (toolbox) => ({
  type: types.SET_EMPLOYEE_TOOLBOX,
  payload: toolbox,
})

export const setRefetchToolboxes = (boolean) => ({
  type: types.REFETCH_TOOLBOXES,
  payload: boolean,
})

export const setAdminLayouts = (layouts) => ({
  type: types.SET_ADMIN_LAYOUTS,
  payload: layouts,
})

export const setManagerLayouts = (layouts) => ({
  type: types.SET_MANAGER_LAYOUTS,
  payload: layouts,
})

export const setEmployeeLayouts = (layouts) => ({
  type: types.SET_EMPLOYEE_LAYOUTS,
  payload: layouts,
})

export const saveToolbox =
  (dashboardId, toolbox, newToolbox, mode) => (dispatch, getState) => {
    const { adminToolbox } = getState().addWidget
    const adminToolboxIds =
      adminToolbox && adminToolbox.map((toolbox) => toolbox.id)

    if (mode !== 'sync' && adminToolboxIds.includes(newToolbox.id)) {
      alert('Widget id already exists')
      return
    }

    if (!newToolbox.id.trim()) {
      alert('Widget id cannot be empty')
      return
    }

    if (!newToolbox.name.trim()) {
      alert('Widget name cannot be empty')
      return
    }

    if (!newToolbox.layout.h.trim()) {
      alert('Widget height cannot be empty')
      return
    }

    if (!newToolbox.layout.w.trim()) {
      alert('Widget width cannot be empty')
      return
    }

    if (!newToolbox.layout.y.trim()) {
      alert('Widget yPos cannot be empty')
      return
    }

    if (!newToolbox.layout.x.trim()) {
      alert('Widget xPos cannot be empty')
      return
    }

    AxiosInstance.patch(
      '/users/update-toolbox',
      {
        toolbox: toolbox,
        id: dashboardId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    )
      .then(() => {
        dispatch(setRefetchToolboxes(true))
      })
      .catch((error) => {
        console.error('Error updating layout:', error)
      })
  }

export const removeToolbox =
  (dashboardId, toolbox, layouts) => (dispatch, getState) => {
    // eslint-disable-next-line
    if (!confirm('Are you sure you want to remove this widget?')) {
      return
    }

    AxiosInstance.patch(
      '/users/update-layout',
      {
        layouts,
        id: dashboardId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    ).catch((error) => {
      console.error('Error updating layout:', error)
    })

    AxiosInstance.patch(
      '/users/update-toolbox',
      {
        toolbox: toolbox,
        id: dashboardId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    )
      .then(() => {
        dispatch(setRefetchToolboxes(true))
      })
      .catch((error) => {
        console.error('Error updating layout:', error)
      })
  }
